import { render } from "./CustomerTypesCell.vue?vue&type=template&id=ca2d8da0&scoped=true"
import script from "./CustomerTypesCell.vue?vue&type=script&lang=js"
export * from "./CustomerTypesCell.vue?vue&type=script&lang=js"

import "./CustomerTypesCell.vue?vue&type=style&index=0&id=ca2d8da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca2d8da0"]])

export default __exports__